import styled from 'styled-components';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const Col = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Button = styled.button`
    min-width: max-content;
`;
